import React, { PureComponent } from 'react';
import styles from './style.module.css'
import Header from './../../components/header/Header'
import services from './../../services/index'

import ItensPedidoNaMesa from '../../components/itensPedidosNaMesa';


import InfoLojaEstouNaMesa from './../../components/infoLojaEstouNaMesa';
import { faPlus, faMinus, faTrashAlt, faCheckCircle, faTimesCircle, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faShoppingCart, } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from './../../components/loading/Loading';
import { Modal, Button } from 'react-bootstrap';
import { FaArrowCircleUp } from "react-icons/fa"
import { isArray, isEmpty } from "lodash"
import GLOBAL from '../../global';

import imgIndisponivel from "./indisponivel.jpg"

import { connect } from "react-redux";
import { bindActionCreators } from "redux"
import * as Actions from "../../store/actions"
import storage from "../../services/storage"
import { withRouter } from "react-router-dom";
import Requests from "../../services/requests"
import {
	InputQt,
	ColumnContainer,
	InputCPF,
	CustomModal
} from "./style"





class EstouNaMesa extends PureComponent {



	state = {
		loja: {},
		subItem: '',
		taxa: 0,
		subtotal: 0,
		itens: [],
		copyItens: [],
		extras: [],
		extras_grande: [],
		extras_brotos: [],
		itensPedido: [],
		itensTemplates: [],
		tempProdsCombo: [],
		loadingPage: false,
		itemNow: {},
		qtItem: 1,
		total: 0,
		isEdit: false,
		indexEdit: null,
		showBordas: false,
		obsNow: '',
		displayItemDetail: 'none',
		massas: [],
		bordas: [],
		totalDoItem: 0.00,
		pelaMaior: false,
		showItemModal: false,
		obsItemPizza: '',
		objTempLancPizza: { produtos: [], massa: {}, borda: {}, toppings: [], obs: '' },
		heightCar: '47px',
		lojaAberta: false,
		showAlertSucces: false,
		textAlertSucces: '',
		showAlertError: false,
		textAlertError: '',
		produtosGratis: [],
		lancProdGratis: {},
		showPic: false,
		imgNow: '',
		prodNow: '',
		descriNow: '',
		textFilter: '',
		rightUpBtn: false,
		displayBanner: 'none',
		selectedCat: 0,
		itemsMenu: [],
		showGetCPF: false,
		cpfTyped: "",
		mesa: "",
		statusTable: 0
	}

	handleScroll = () => {
		let scroll = document.documentElement.scrollTop;

		if (this.state.itemsMenu.length > 0) {
			const refName = this.state.itemsMenu[0]['id'] + "scroll";
			if (!isEmpty(this[refName])) {
				const lasIndex = this.state.itemsMenu.length - 1;
				const { current: lastCurrent } = this[`${this.state.itemsMenu[lasIndex]['id']}scroll`];
				this.state.itemsMenu.map((i, index) => {
					if (this.state.itemsMenu[index + 1]) {
						const { current } = this[i['id'] + "scroll"];
						const { current: Current2 } = this[`${this.state.itemsMenu[index + 1]['id']}scroll`]

						if ((scroll >= (current.offsetTop - 100)) && (scroll <= (Current2.offsetTop - 100))) {
							this.setState({ selectedCat: index })
						} else if ((scroll) >= lastCurrent.offsetTop) {
							this.setState({ selectedCat: lasIndex })
						}
					}
				})
			}
		}
		if (scroll > 800) {
			if (this.state.rightUpBtn === false && this.state.heightCar === '47px') {
				this.setState({ rightUpBtn: true });
			}
		} else {
			if (this.state.rightUpBtn === true) {
				this.setState({ rightUpBtn: false });
			}
		}
	}


	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	scrolltoTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	}

	async componentDidMount() {
		await this.getStores();

		const itensMenu = [];
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});

		this.props.setAdressToDelivery({});

		try {
			window.addEventListener('scroll', this.handleScroll);


			if (this.state.loja) {
				let { taxa_entrega } = this.state.loja;




				this.setState({ taxa: taxa_entrega });
				this.setState({ loadingPage: true });

				let gratis = [];
				let AllProds = [];

				try {
					const { id_loja } = this.state.loja;
					AllProds = await services.getAllProducts(id_loja);
				} catch (error) {
					console.log(error);
					return;
				}



				AllProds.data.forEach((element, index) => {

					const id = `${element.categoria.split(' ')[0]}${index}`
					element.id = id;
					itensMenu.push({ item: element.categoria, id });


					let produtos = element.produtos.filter(obj => obj.is_extra === 'N');
					let prodsComPromoGratis = produtos.filter(obj => obj.is_promo === 'S' && obj.prodsPromoGratis.length > 0);


					if (prodsComPromoGratis.length > 0) {

						prodsComPromoGratis.forEach(item => {
							let prodsGratis = item.prodsPromoGratis;
							let i = 0;
							prodsGratis.map(o => {
								i === 0 ? o.selected = true : o.selected = false;
								o.id_template = item.id_template_promo_prod_gratis;
								i++;

							});


							prodsGratis.forEach(item => {
								let aux = gratis.filter(o => o.id_produto === item.id_produto);
								if (aux.length === 0)
									gratis.push(item)
							});


						})

					}


					element.produtos = produtos;

				});

				AllProds.data.forEach(i => {
					this[`${i.id}scroll`] = React.createRef();
				})

				this.setState({ itens: AllProds.data, produtosGratis: gratis, copyItens: AllProds.data, itemsMenu: itensMenu });


				let rExtras = [];

				try {
					rExtras = await services.getExtras(this.state.loja.id_loja);
				} catch (error) {
					console.log(error);
					return;
				}

				const { produtos: extras } = rExtras.data;
				this.setState({ extras: extras });



				let rMassasBordas = [];
				try {
					rMassasBordas = await services.getMassasAndBordas();
				} catch (error) {
					console.log(error);
					return;
				}

				const { massas, bordas } = rMassasBordas.data.massasandbordas;

				massas.map(o => o.selected = false);

				bordas.map(o => o.selected = false);

				this.setState({ massas: massas, bordas: bordas });

				const bodyRequest = {
					tableNumber: this.props.match.params.mesa,
					storeID: this.state.loja.id_loja
				}
				let itens = await services.getItensMesaFromApi(bodyRequest);

				if (itens.length > 0) {

					this.props.setItens(itens);
					this.setState({ itensPedido: itens, statusTable: itens[0].finalizado }, () => {
						this.calculaTotal()
						this.totalizaCompra();
					});
				} else {
					this.props.setItens([]);
				}


				this.setState({ loadingPage: false });

			}
		} catch (error) {
			this.setState({ loadingPage: false });
			console.log(error);
		}

	}






	getStores = async () => {
		try {
			services.setAskPromo(false);

			const idLoja = this.props.match.params.idLoja;
			const mesa = this.props.match.params.mesa;
			const lojas = await Requests.getStores();

			if (lojas.error) {
				return alert('Ops... Algo deu errado. Vamos tentar novamente');
			}

			if (lojas.length === 0) {
				return alert('Ops... Nenhuma loja encontrada');
			}

			const auxLoja = lojas.filter(i => i.id_loja === Number(idLoja))[0];

			this.setState({ loja: auxLoja, mesa });

			this.props.setStores(lojas);
			services.setLastStore(JSON.stringify(lojas));
		} catch (error) {
			return alert("Ops... Algo deu errado.")
		}
	}







	handleExcludeItem = () => {
		try {
			let exclui = window.confirm('Deseja realmente excluir esse item ?');

			if (!exclui) return;

			let newArr = [];
			newArr = JSON.parse(JSON.stringify(this.state.itensPedido));
			newArr.splice(this.state.indexEdit, 1);
			this.props.setItens(newArr);
			this.setState({ itensPedido: newArr }, () => {
				this.calculaTotal();
				services.setTempPedido(JSON.stringify(newArr));
			});
			this.closeModal();
			this.totalizaCompra();
		} catch (err) {
			console.log(err);
			this.closeModal();
		}
	}


	totalizaCompra = () => {
		let tot = services.totalizaItens(this.props.rdOrder.itens, 0, '', true);
		if (tot) {
			this.setState({ total: tot.data.total.toFixed(2) });
		}
	}

	handleObs = (e) => {
		this.setState({ obsNow: e.target.value });
	}


	editItem = (item, index) => {

		this.recuperaItensParaEdicao(item);

		this.setState({ qtItem: item.quantidade, isEdit: true, indexEdit: index }, () => {
			this.openItem(item);
		});
	}

	plusItem = (e) => {
		e.preventDefault();
		this.setState({ qtItem: this.state.qtItem + 1 }, () => {
			if (this.state.showItemModal) this.calculaTotal();
		});
	}

	minusItem = (e) => {
		e.preventDefault();
		if (this.state.qtItem === 1) return
		this.setState({ qtItem: this.state.qtItem - 1 }, () => {
			if (this.state.showItemModal) this.calculaTotal();
		});
	}

	resolveImage = (imagem) => {
		return imagem ? `${imagem}` : imgIndisponivel
	}

	async openItem(itemP) {
		try {


			this.setState({ loadingPage: true });

			if (!this.state.isEdit) this.zeraCheckandRaios(itemP);

			let item = JSON.parse(JSON.stringify(itemP));
			let qt = item.quantidade

			if (!qt) qt = 1;

			if (item.partes) {
				this.setState({
					itemNow: item,
					qtItem: qt,
					showItemModal: true,
					obsNow: item.obs,
					obsItemPizza: item.obs,
					itensTemplates: item.prod_of_template,
					objTempLancPizza: item.partes,
					totalDoItem: item.total,
					pelaMaior: itemP.maior
				});
			} else {

				this.setState({
					showItemModal: true,
					itemNow: item,
					obsNow: item.obs,
					itensTemplates: item.prod_of_template,
					totalDoItem: item.PRECO,
					pelaMaior: itemP.maior,
					qtItem: qt,
				});
			}
			this.setState({ loadingPage: false });
		} catch (error) {
			this.setState({ loadingPage: false });
			console.log(error);
		}

	}

	isEmpty(obj) {
		for (var prop in obj) {
			if (obj.hasOwnProperty(prop))
				return false;
		}

		return true;
	}

	hasPromoLanc = (any) => {
		let result = false;

		this.state.itensPedido.forEach(obj => {
			// if any is equals true, it has to verify if there are any promotion. On ther other hand, verify only if there is free soda
			if (any) {
				if (obj.is_promo === 'S') result = true
			} else {
				if (!this.isEmpty(obj.partes.prodGratis)) result = true
			}

		});
		return result;
	}








	addItem = () => {
		if (this.state.statusTable === 2) return this.resolveAlert("Conta já solicitada", true)
		try {
			if (this.isEmpty(this.state.objTempLancPizza.prodGratis) && this.state.itemNow.is_promo === 'S') {
				if (this.hasPromoLanc(false)) {
					this.resolveAlert('Promoção não cumulativa. Você já tem uma promoção lançada', true);
					return;
				}
			}

			if (this.state.objTempLancPizza.produtos.length < this.state.itemNow.qt_particiona) {
				this.resolveAlert('Para concluir o pedido, é necessário concluir o número de partes necessárias', true);
				return
			}

			if (this.state.itemNow.is_combo === 'S') {
				if (this.state.tempProdsCombo.length < this.state.itemNow.qtItensCombo) {
					this.resolveAlert('Escolhe todas as partes do combo', true);
					return
				}
			}


			if (this.state.objTempLancPizza.massa) {
				if (this.state.objTempLancPizza.massa.aceita_borda === 'S' && this.isEmpty(this.state.objTempLancPizza.borda)) {
					this.resolveAlert('Por ter escolhido uma massa com borda, se torna obrigatório a escolha da borda', true);
					return
				}
			}

			let obj = JSON.parse(JSON.stringify(this.state.itemNow));
			let arrPedidos = this.props.rdOrder.itens;
			const partesOfCombo = this.state.tempProdsCombo;

			obj['quantidade'] = this.state.qtItem;
			obj['obs'] = this.state.obsItemPizza;
			obj['total'] = this.state.totalDoItem;



			let subtotal_item = this.state.itemNow.PRECO * this.state.qtItem;

			obj['subtotal'] = parseFloat(subtotal_item.toFixed(2));

			let valMaiorPizza = 0;

			if (this.state.pelaMaior) {
				const objMaior = services.getMaiorPreco(this.state.objTempLancPizza.produtos);
				if (objMaior) {
					valMaiorPizza = objMaior.PRECO;
				}
			} else {
				valMaiorPizza = services.getMediaPreco(this.state.objTempLancPizza.produtos);
				if (valMaiorPizza === 0) valMaiorPizza = this.state.itemNow.PRECO;
			}

			obj['valMaiorPizza'] = valMaiorPizza;

			let borda = {};

			if (obj.aceita_borda === 'S' && this.state.objTempLancPizza.borda && this.state.objTempLancPizza.massa
				&& this.state.objTempLancPizza.massa.aceita_borda === "S"
			) {
				borda = this.state.objTempLancPizza.borda;
			}




			obj['partes'] = {
				produtos: this.state.objTempLancPizza.produtos || [],
				massa: obj.aceita_massa === 'S' && this.state.objTempLancPizza.massa ? this.state.objTempLancPizza.massa : {},
				borda,
				toppings: obj.aceita_extra === 'S' && this.state.objTempLancPizza.toppings ? this.state.objTempLancPizza.toppings : [],
				prodGratis: !this.hasPromoLanc(true) && this.state.itemNow.is_promo === 'S' ? this.state.objTempLancPizza.prodGratis : {},
				partesCombo: partesOfCombo
			}


			obj['total'] = this.state.totalDoItem;
			obj['enviado'] = false;


			obj['is_mesa'] = true;



			arrPedidos.push(obj);

			this.props.setItens(arrPedidos);

			this.setState({ itensPedido: arrPedidos, itemNow: {} });

			this.persistNewItens(arrPedidos);
			this.closeModal();


		} catch (error) {
			console.log(error);
		}
	}



	persistNewItens = (arrPedidos) => {
		services.setTempPedido(JSON.stringify(arrPedidos));
		this.calculaTotal();
		this.totalizaCompra();
	}



	handleEdit = () => {
		try {
			let obj = JSON.parse(JSON.stringify(this.state.itemNow));

			if (obj.is_pizza) {
				if (this.state.objTempLancPizza.produtos.length < obj.qt_particiona) {
					this.resolveAlert('Para finalizar, é necessário selecionar as partes, ou excluir o item', true);
					return;
				}
				obj['quantidade'] = this.state.qtItem;
				obj['obs'] = this.state.obsItemPizza;
				obj['total'] = this.state.totalDoItem;
				obj['PRECO'] = this.state.itemNow.PRECO;
				obj['partes'] = this.state.objTempLancPizza;
				obj.partes.partesCombo = this.state.tempProdsCombo;
				obj['obs'] = this.state.obsItemPizza;
			} else {
				obj.quantidade = this.state.qtItem;
				let totItem = (obj.PRECO * this.state.qtItem);
				obj['total'] = totItem;
				obj['obs'] = this.state.obsNow || this.state.obsItemPizza;
			}


			let arrPedidos = this.state.itensPedido;
			arrPedidos[this.state.indexEdit] = obj;

			this.props.setItens(arrPedidos);
			this.setState({ itensPedido: arrPedidos, qtItem: 1, isEdit: false, indexEdit: null });

			services.setTempPedido(JSON.stringify(arrPedidos));

			this.calculaTotal();
			this.totalizaCompra();
			this.closeModal();
		} catch (error) {
			console.log(error);
		}

	}

	closeModal = () => {
		try {
			this.zeraCheckandRaios();

			let pizza = this.state.itemNow.is_pizza === 'S' && this.state.itemNow.qt_particiona > 1;

			this.setState({
				itemNow: {},
				qtItem: 1,
				isEdit: false,
				obsNow: '',
				itensTemplates: [],
				showBordas: false,
				tempProdsCombo: [],
				maior: false
			});

			if (pizza) {
				let itensTemp = JSON.parse(JSON.stringify(this.state.objTempLancPizza));

				itensTemp.produtos = [];
				itensTemp.toppings = [];

				this.setState({ showItemModal: false, objTempLancPizza: itensTemp, totalDoItem: 0 })
			} else {
				this.setState({ showItemModal: false });
			}
		} catch (error) {
			console.log(error);
		}
	}

	handleCheckExtra = (indexExtras, id_template, e) => {
		// Criar regra para não selecionar + que três toppings
		try {

			let objTemp = JSON.parse(JSON.stringify(this.state.objTempLancPizza));
			let arrExtras = JSON.parse(JSON.stringify(this.state.extras));



			let arrWithout = arrExtras.filter(e => e.id_template_extra !== id_template) || [];
			let rightExtras = arrExtras.filter(e => e.id_template_extra === id_template) || [];

			if (rightExtras.filter(o => o.selected === true).length === 3 && e.target.checked) {
				this.resolveAlert('Só é permitida a escolha de no máximo 3 extras', true);
				return;
			}

			rightExtras[indexExtras].selected = e.target.checked;

			let id = rightExtras[indexExtras].ID_PRODUTO;

			let index = objTemp.toppings.map((item, index) => {
				item.index = index;
				return item;
			}).find(item => item.ID_PRODUTO === id);

			if (index) index = index.index;

			if (e.target.checked) {
				objTemp.toppings.push(rightExtras[indexExtras]);
			} else {
				objTemp.toppings.splice(index, 1);
			}


			let newArrToPut = arrWithout.concat(rightExtras);

			this.setState({ extras: newArrToPut, objTempLancPizza: objTemp }, () => this.calculaTotal());
		} catch (error) {
			console.log(error);
		}

	}


	handleCheckProd(indexProdTemplate, e) {

		try {

			let newArr = JSON.parse(JSON.stringify(this.state.itensTemplates));
			newArr[indexProdTemplate].selected = e.target.checked;
			let id = newArr[indexProdTemplate].ID_PRODUTO;

			let newObj = JSON.parse(JSON.stringify(this.state.objTempLancPizza));

			let index = newObj.produtos.map((item, index) => {
				item.index = index
				return item
			}).find(item => item.ID_PRODUTO === id);

			if (index) index = index.index;


			if (e.target.checked) {
				if (newObj.produtos.length === this.state.itemNow.qt_particiona) {
					e.preventDefault();
					this.resolveAlert('Número de partes para esse produto antigido', true);
					return;
				}

				newObj.produtos.push(newArr[indexProdTemplate]);
			}
			else newObj.produtos.splice(index, 1);


			this.setState({ itensTemplates: newArr, objTempLancPizza: newObj }, () => this.calculaTotal());
		} catch (error) {
			console.log(error);
		}

	}

	resolveAlert = (text, danger) => {
		if (text) {
			if (danger) {
				this.setState({ showAlertError: true, textAlertError: text });
			} else {
				this.setState({ showAlertSucces: true, textAlertSucces: text })
			}
		}
	}

	handleCloseAll = () => {
		this.setState({ showAlertError: false, showAlertSucces: false, textAlertError: '', textAlertSucces: '' });
	}


	calculaTotal = () => {
		try {

			let totalizador = 0;
			if (!this.state.objTempLancPizza) {
				totalizador = this.state.itemNow.PRECO * this.state.qtItem;
			} else {
				// produtos e toppings são um array
				const { produtos, borda, massa, toppings } = this.state.objTempLancPizza;

				let maior = {};
				let valProduto = 0;
				let valMassa = 0;
				let valBorda = 0;
				let valToppings = 0;

				if (this.state.itemNow.is_pizza === 'S' && this.state.itemNow.qt_particiona > 1) {
					if (this.state.pelaMaior) {
						maior = services.getMaiorPreco(produtos);
						if (maior && 'PRECO' in maior) valProduto = maior.PRECO
						else {
							valProduto = this.state.itemNow.PRECO;
						}
					} else {
						valProduto = services.getMediaPreco(produtos);
						if (valProduto === 0) valProduto = this.state.itemNow.PRECO;
					}
				} else {
					valProduto = this.state.itemNow.PRECO;
				}





				if (massa && 'preco' in massa) valMassa = massa.preco;

				if (borda && ('preco' in borda) && this.state.showBordas) valBorda = borda.preco;

				if (toppings) {
					valToppings = toppings.reduce((total, element) => {
						return total + element.PRECO;
					}, 0);
				}

				totalizador = (valProduto + valMassa + valBorda + valToppings) * this.state.qtItem;
			}

			this.setState({ totalDoItem: totalizador });
		} catch (error) {
			console.log(error);
		}
	}


	handleCheckProdPomo = (index, e) => {
		try {

			let newArr = JSON.parse(JSON.stringify(this.state.produtosGratis));

			newArr.map(o => o.selected = false);
			newArr[index].selected = e.target.checked;

			this.setState({ produtosGratis: newArr });

			let itens = JSON.parse(JSON.stringify(this.state.objTempLancPizza));

			if (e.target.checked) itens.prodGratis = newArr[index];


			this.setState({ objTempLancPizza: itens }, () => this.calculaTotal());
		} catch (error) {
			console.log(error);
		}

	}

	zeraBordas = () => {
		let newBordas = JSON.parse(JSON.stringify(this.state.bordas));
		newBordas.map(b => b.selected = false);
		this.setState({ bordas: newBordas });
	}

	handleCheckMassa = (indexMassas, e) => {
		try {

			let newArr = JSON.parse(JSON.stringify(this.state.massas));

			newArr.map(o => o.selected = false);
			newArr[indexMassas].selected = e.target.checked;

			this.setState({ massas: newArr });

			let itens = JSON.parse(JSON.stringify(this.state.objTempLancPizza));

			if (e.target.checked) {

				if (newArr[indexMassas].aceita_borda === 'S') {
					this.setState({ showBordas: true });
				} else {
					this.zeraBordas();
					this.setState({ showBordas: false });
					itens.borda = {};
				}
				itens.massa = newArr[indexMassas];
			} else {
				this.zeraBordas();
				this.setState({ showBordas: false });
				itens.borda = {};
			}


			this.setState({ objTempLancPizza: itens }, () => this.calculaTotal());
		} catch (error) {
			console.log(error);
		}

	}

	handleCheckBordas = (indexBordas, e) => {
		try {
			let newArr = JSON.parse(JSON.stringify(this.state.bordas));

			newArr.map(o => o.selected = false);
			newArr[indexBordas].selected = e.target.checked;

			this.setState({ bordas: newArr });

			let itens = JSON.parse(JSON.stringify(this.state.objTempLancPizza));

			if (e.target.checked) itens.borda = newArr[indexBordas];

			this.setState({ objTempLancPizza: itens }, () => this.calculaTotal());
		} catch (error) {
			console.log(error);
		}

	}


	handleObsPizza = (e) => {
		this.setState({ obsItemPizza: e.target.value });
	}


	veirificaLojaAberta = async () => {
		let lojaAberta = await services.verficaLojaAberta(this.state.loja.id_loja);
		this.setState({ lojaAberta: lojaAberta });
		return lojaAberta;
	}


	recuperaItensParaEdicao = (item) => {
		try {
			//Primeiramente, vamos dar um reset no states necessários para operação

			this.zeraCheckandRaios();
			const { partesCombo } = item.partes;

			if (item.partes) {
				/*Aqui eu vou percorrer todas as partes desse produto para pegar o ID e setar selectec nos prod_of_template, 
				Pois todo o procedimento de lançamento é feito nele.
				Então é um map para os produtos, e dentro um find baseado no id da iteração. Daí procuro no prod_of... 
				o ID referente e seto para seleted true, pois assim ele vai aparecer checado na view de edição
				*/
				if (item.prod_of_template) {
					item.prod_of_template.map(o => o.selected = false);
					item.partes.produtos.forEach(produtos => {
						let prodFilter =

							item.prod_of_template.find(prodtemplate => {
								return prodtemplate.ID_PRODUTO === produtos.ID_PRODUTO
							});

						if (prodFilter) {
							prodFilter.selected = true
						}
					});
				}


				/*Agora vamos veririficar se há massa nesse pedido
				* As bordas, extras e massas são states separados já preenchidos no componentDidMount.
				* Portanto, devemos pegar o item recebido para edição, verificar se há qualquer um desses 
				* Eles não são um array, basta um find e um seletecd = true caso seja o caso 
				*/

				if (item.partes.massa) {

					let stateMassas = JSON.parse(JSON.stringify(this.state.massas));
					stateMassas.map(o => o.selected = false);
					let massaAchou = stateMassas.find(massa => massa.id_massa === item.partes.massa.id_massa);

					let showBordas = false;
					if (massaAchou) {
						massaAchou.selected = true;
						if (massaAchou.aceita_borda === 'S') showBordas = true;

					}

					this.setState({ massas: stateMassas, showBordas: showBordas });
				}

				/**
				 * Agora devemos faer o mesmo esquemapara as bordas. Verifica se tem bora e etc...  
				 * */

				if (item.partes.borda) {

					let stateBordas = JSON.parse(JSON.stringify(this.state.bordas));
					stateBordas.map(o => o.selected = false);
					let bordaAchou = stateBordas.find(borda => borda.id_borda === item.partes.borda.id_borda);

					if (bordaAchou) bordaAchou.selected = true;

					this.setState({ bordas: stateBordas });
				}

				/**Agora devemos fazer um metodo semelhante com os toppings. Porém eles são produtos de fato, então 
				 * esse metodo deve ser parecido com o primeiro. Acontece que os toppings são os nossos extras. Iremos 
				 * percorrer os toppings, achar esse topping no array extras e setar o array extra para selected true 
				 */

				if (item.partes.toppings) {
					let stateExtras = JSON.parse(JSON.stringify(this.state.extras));
					stateExtras.map(o => o.selected = false);

					item.partes.toppings.map(topping => {
						stateExtras = stateExtras.map(e => {
							if (e.id_produto === topping.id_produto) {
								return {
									...e,
									selected: true
								}
							} else {
								return { ...e }
							}
						})

					})



					this.setState({ extras: stateExtras });
				}


				/**Agora devemos verificar se é um combo e se á produtos lançados nele */
				if (partesCombo && partesCombo.length > 0) {
					this.setState({ tempProdsCombo: partesCombo });
				}

				/**
				 * Agora vamos procurar para saber se há observação
				 */

				if (item && item.obs) {
					this.setState({ obsItemPizza: item.obs });
				}

			}
		} catch (error) {
			console.log(error);
		}
	}



	goToCart = () => {
		if (this.state.heightCar != '100%') this.setState({ heightCar: '100%' }, () => {
			if (this.state.rightUpBtn) this.setState({ rightUpBtn: false })
		});
	}



	closeCar = () => {
		this.setState({ heightCar: '47px' });
	}



	zeraCheckandRaios = (item) => {
		try {

			let newItens = JSON.parse(JSON.stringify(this.state.itens));
			newItens.map(item => {
				item.produtos.map(prods => {
					if (prods.prod_of_template)
						prods.prod_of_template.map(o => o.selected = false);
				})
			});

			let newMassas = JSON.parse(JSON.stringify(this.state.massas));
			let newBordas = JSON.parse(JSON.stringify(this.state.bordas));
			let newExtras = JSON.parse(JSON.stringify(this.state.extras));

			let itensTemp = JSON.parse(JSON.stringify(this.state.objTempLancPizza));

			itensTemp.obs = '';

			itensTemp.massa = {};
			itensTemp.toppings = [];
			itensTemp.borda = {};



			if (item.aceita_massa === "S") {
				newMassas.map(o => {
					if (o.principal === 'S') {
						o.selected = true;
						itensTemp.massa = o;
					} else {
						o.selected = false
					}
				});
			}

			if (item.aceita_borda === "S") {
				newBordas.map(o => {
					if (o.principal === 'S') {
						o.selected = true;
						itensTemp.borda = o;
					} else {
						o.selected = false
					}
				});
			}

			let arrProdsGratis = [];
			if (item) {
				if (item.id_template_promo_prod_gratis != null) {
					arrProdsGratis = this.state.produtosGratis.filter(o => o.id_template === item.id_template_promo_prod_gratis);
					if (arrProdsGratis) {
						itensTemp.prodGratis = arrProdsGratis[0];
					}
				} else {
					itensTemp.prodGratis = {};
				}
			} else {
				itensTemp.prodGratis = {};
			}

			newExtras.map(o => o.selected = false);

			this.setState({
				itens: newItens,
				massas: newMassas,
				bordas: newBordas,
				extras: newExtras,
				obsItemPizza: '',
				objTempLancPizza: itensTemp
			});

		} catch (error) {
			console.log(error);
		}

	}

	viewPic = (item) => {
		//800 x 620
		this.setState({ showPic: true, imgNow: item.imagem, descriNow: item.descricao, prodNow: item.produto });
	}

	handleCloseImgNow = () => {
		this.setState({ showPic: false, imgNow: '', descriNow: '', prodNow: '' });
	}






	filterProd = (e) => {
		this.functionFlter(this.state.itens, 'batata');
		this.setState({ textFilter: e.target.value }, () => {
			if (this.state.textFilter != '') {
				this.setState({ itens: this.functionFlter(this.state.copyItens, this.state.textFilter) })
			} else {
				this.setState({ itens: this.state.copyItens });
			}
		});
	}




	functionFlter = (arr, text) => {
		let result = [];
		text = text.toUpperCase();
		arr.forEach(item => {
			let produtos = []
			for (let i = 0; i < item.produtos.length; i++) {
				if (item.produtos[i].descricao) {
					if (item.produtos[i].produto.toUpperCase().indexOf(text) > -1 || item.produtos[i].descricao.toUpperCase().indexOf(text) > -1) {

						produtos.push(item.produtos[i]);
					}
				} else {
					if (item.produtos[i].produto.toUpperCase().indexOf(text) > -1) {

						produtos.push(item.produtos[i]);
					}
				}

			}
			if (produtos.length > 0) {
				let auxItem = {
					'categoria': item.categoria,
					produtos: produtos
				}

				result.push(auxItem);
			}
		})
		return result;
	}



	cleanTextSearch = () => {
		this.setState({ textFilter: '', itens: this.state.copyItens });
	}



	handeCheckParteCombo = (produto, categoria, e) => {
		let tempProdsCombo = JSON.parse(JSON.stringify(this.state.tempProdsCombo));
		produto.categoria = categoria.categoria;
		let filterTemp = tempProdsCombo.filter(o => o.categoria != produto.categoria);
		filterTemp.push(produto);
		this.setState({ tempProdsCombo: filterTemp });

	}


	resolveCheckCombo = (e, item) => {
		let r = this.state.tempProdsCombo.filter(o => o.id_produto === item.id_produto);
		if (r.length > 0) {
			return true
		} else {
			return false;
		}
	}




	// Metodo que monta toda a view da seleção do produto
	montaView = () => {
		const itenNow = this.state.itemNow;
		const prodsOfCombo = this.state.itemNow.prods_of_combo;
		let itensPromo = [];


		if (itenNow.is_promo === 'S' && !this.hasPromoLanc(true) && itenNow.id_template_promo_prod_gratis != null) {
			itensPromo = this.state.produtosGratis.filter(o => o.id_template === itenNow.id_template_promo_prod_gratis);
		}

		// Aqui é o combo        
		if (itenNow.is_combo === 'S') {
			return (
				<div>
					{
						prodsOfCombo.map(item => {
							return (
								<div>
									<p><strong>{item.categoria}</strong></p>
									{
										item.produtos.map((p, index) => {
											return (
												<div className="row" key={index}>
													<div className="col-md-9 col-sm-9 col-xs-7">
														<label><input type="radio" name={`${item.categoria}`} onChange={this.handeCheckParteCombo.bind(this, p, item)} checked={this.resolveCheckCombo(this, p)} /> {p.produto}</label>
													</div>
													<div className="col-md-3 col-sm-3 col-xs-5">
														<p className="text-right">R$ {p.PRECO.toFixed(2)}</p>
													</div>
												</div>
											)
										})
									}
								</div>
							)
						})
					}
				</div>
			)

		} else {
			// Aqui é a pizza
			return (
				<div>
					{
						this.state.itensTemplates && this.state.itensTemplates.length > 0 ? (
							<div className="produtosescolhe">
								<p className="titleListChoose">Escolha os sabores : </p>
								{
									this.state.itensTemplates.map((item, index) => {
										return (
											<div key={item.ID_PRODUTO}>
												<div className="row separaItensPizza">
													<div className="col-md-9 col-sm-9 col-xs-7">
														<label htmlFor={`prod${index}`}><input type="checkbox" name="prod" id={`prod${index}`} checked={item.selected} onClick={this.handleCheckProd.bind(this, index)} /> {item.produto} :</label>
														<p className="descriProdPede">{item.descricao}</p>
													</div>
													<div className="col-md-3 col-sm-3 col-xs-5">
														<p className="text-right">R$ {item.PRECO.toFixed(2)}</p>
													</div>
												</div>
											</div>
										);
									})
								}
							</div>
						) : ''
					}




					{/* Inicia Massa */}
					{
						this.state.itemNow.aceita_massa === 'S' ? (
							<div className="massas">
								<p className="titleListChoose">Escolha sua massa</p>
								{
									this.state.massas.map((massa, index) => {
										return (
											<div className="row" key={index}>
												<div className="col-md-9 col-sm-9 col-xs-7">
													<label><input type="radio" name="massa" onChange={this.handleCheckMassa.bind(this, index)} checked={massa.selected} /> {massa.descricao}</label>
												</div>
												<div className="col-md-3 col-sm-3 col-xs-5">
													<p className="text-right">R$ {massa.preco.toFixed(2)}</p>
												</div>
											</div>
										)
									})
								}
							</div>
						) : ''
					}





					{/* Inicia bordas */}
					{
						itenNow.aceita_borda === 'S' && this.state.showBordas ? (
							<div className="bordas">
								<p className="titleListChoose">Escolha sua borda</p>
								{
									this.state.bordas.map((borda, index) => {
										return (
											<div className="row" key={borda.id_borda}>
												<div className="col-md-9 col-sm-9 col-xs-7">
													<label><input type="radio" name="borda" checked={borda.selected} onChange={this.handleCheckBordas.bind(this, index)} /> {borda.descricao}</label>
												</div>
												<div className="col-md-3 col-sm-3 col-xs-5">
													<p className="text-right">R$ {borda.preco.toFixed(2)}</p>
												</div>
											</div>
										)
									})
								}
							</div>
						) : ''
					}



					{/* Inicia Toppings */}
					{
						itenNow.aceita_extra === 'S' && this.state.extras.length > 0 && itenNow.id_template_extra != null ? (
							<div className="toppingsEscolhe">
								<p className="titleListChoose">Escolha seus extras</p>
								{
									this.state.extras.filter(i => i.id_template_extra === itenNow.id_template_extra).map((extras, index) => {
										return (
											<div className="row" key={index}>
												<div className="col-md-9 col-sm-9 col-xs-7">
													<label><input type="checkbox" name="toppings" checked={extras.selected} onChange={this.handleCheckExtra.bind(this, index, itenNow.id_template_extra)} />{extras.produto}</label>
												</div>
												<div className="col-md-3 col-sm-3 col-xs-5">
													<p className="text-right">R$ {extras.PRECO.toFixed(2)}</p>
												</div>
											</div>
										)
									})
								}
							</div>
						) : ''
					}




					{
						itenNow.is_promo === 'S' && !this.hasPromoLanc(true) && itenNow.id_template_promo_prod_gratis != null ? (

							<div className="massas">
								<p className="titleListChoose">Escolha seu produto grátis</p>
								{
									itensPromo.map((prod, index) => {
										return (
											<div className="row" key={index}>
												<div className="col-md-9 col-sm-9 col-xs-7">
													<label><input type="radio" name="prodpromo" onChange={this.handleCheckProdPomo.bind(this, index)} checked={prod.selected} /> {prod.produto}</label>
												</div>
												<div className="col-md-3 col-sm-3 col-xs-5">
													<p className="text-right">R$ 0.00</p>
												</div>
											</div>
										)
									})
								}
							</div>
						) : ''
					}
				</div>
			)
		}
	}




	manualQtAdd = ({ target }) => {
		try {
			let valor = target.value.replace(/\[a-Z]/g, "");

			let auxQt = String(target.value).split(".");
			if (auxQt.length > 1) {
				if (auxQt[1].length === 5) return
			}

			if ((valor.indexOf(",") !== -1) && (valor.indexOf(".") === -1) && valor.length > 0) {
				valor = valor.replace(",", "");
				valor += "."
			} else if ((valor.indexOf(",") !== -1)) {
				valor = valor.replace(",", "");
			}

			const aux = valor.split("");
			let aux1 = 0;
			aux.forEach(v => v === "." && aux1++);
			if (aux1 > 1) {
				aux.splice(aux.length - 1, 1);
				valor = aux.join("");
			}

			this.setState({ qtItem: valor }, () => {
				if (this.state.showItemModal) this.calculaTotal();
			});
		} catch (error) {
			console.log(error)
		}
	}




	handleCpfTyped = (e) => {
		this.setState({ cpfTyped: e.target.value });
	}



	handleOkCpf = () => {
		this.closeModalCPF();
		storage.setCPF(this.state.cpfTyped);

	}


	closeModalCPF = () => {
		this.setState({ showGetCPF: false, cpfTyped: "" });
	}



	render() {
		const { itemNow } = this.state;
		const hasItemToSend = this.props.rdOrder.itens.findIndex(i => !i.enviado);

		return (
			<div style={{ background: `#F2F2F2` }}>

				{
					this.state.loadingPage ? (
						<Loading />
					) : ''
				}

				<div className="gotoTop" style={{ right: this.state.rightUpBtn ? '10px' : '-500px' }} onClick={this.scrolltoTop}>
					<FaArrowCircleUp color="#000" />
				</div>

				<div className={`${styles["btn-carrinho"]} hidden-md hidden-sm hidden-lg`} style={{
					display: this.state.itensPedido.length > 0 ? 'block' : 'none',
					height: this.state.heightCar,
					background: hasItemToSend >= 0 ? "#2a9d8f" : "#04152A"
				}} onClick={this.goToCart}>




					{
						hasItemToSend === -1 ? (
							<>
								{
									this.state.heightCar === '47px' ? (
										<span>
											<FontAwesomeIcon icon={faShoppingCart} className="shoppingCartLanc" /> {
												this.state.statusTable === 2 ? "Em conta..." : "Itens"
											}
										</span>

									) : (
										<span onClick={this.closeCar}>
											<FontAwesomeIcon icon={faChevronLeft} className="shoppingCartLanc" /> Voltar
										</span>
									)
								}
							</>
						) : (
							<>
								{
									this.state.heightCar !== '47px' ? (
										<span onClick={this.closeCar}>
											<FontAwesomeIcon icon={faChevronLeft} className="shoppingCartLanc" /> Voltar
										</span>

									) : (
										<span>
											Conferir e enviar pedido <FontAwesomeIcon icon={faChevronRight} className="shoppingCartLanc" />
										</span>
									)
								}
							</>
						)
					}





					<p className="totCarLanc"> R$ {this.state.total}</p>

					<ItensPedidoNaMesa showPag={true}
						itens={this.state.itensPedido}
						loja={this.state.loja}
						openItem={this.editItem}
						taxa={0}
						additionalClass="carAtLanc"
						mesa={this.state.mesa}
						funcAlert={this.resolveAlert}
						funcVerificaLoja={this.veirificaLojaAberta}
					/>
				</div>

				<Header
					items={this.state.itemsMenu}
					selected={this.state.selectedCat}
					showMenuItens
					estouNaMesa
					objTable={
						{
							mesa: Number(this.state.mesa),
							loja: this.state.loja.id_loja
						}
					}
				/>

				<div className="content-pedidos">

					<div className="container">
						<div className="row" style={{ paddingTop: 10 }}>
							<div className="col-md-9">
								<InfoLojaEstouNaMesa {...this.state.loja} mesa={this.state.mesa} />


								{/**Aqui vai um laço com todos os itens separados por categoria */}
								<div className={styles['content-itens-escolhe']}>

									<input value={this.state.textFilter} onChange={this.filterProd} placeholder="Pesquise por produto ou ingrediente" type="text" className={`form-control ${styles.__inputSearch}`} />


									{
										this.state.itens.map((item, index) => {
											return (
												<div className="grupos" key={index} id={item.id}>
													{
														item.produtos.length > 0 ? (
															<h2 href="#" name={index}>
																{item.categoria}
															</h2>
														) : ''
													}

													{/* Na compra de qualquer produto dessa categoria, grátis um refrigerante de 2 litros (Promoção não cumulativa) */}
													{item.informativo != '' && item.informativo != null ? (<p className="infoPromo">{item.informativo}</p>) : ''}

													<div className={`itensGrupo`} ref={this[`${item.id}scroll`]}>
														<div className="row">

															{
																item.produtos.map((element, index) => {
																	return (
																		<div className="col-md-6 col-sm-6" key={index} >
																			<div className={styles.item} >
																				<div className="row ">
																					<div className="col-md-5 col-sm-5 col-xs-5">
																						<div className="imgItem" onClick={() => this.viewPic(element)}>
																							<img src={this.resolveImage(element.imagem)} className="img-responsive" />
																						</div>
																					</div>
																					<div className="col-md-7 col-sm-7 col-xs-7" onClick={() => this.openItem(element, null)}>
																						<div className="descItem">
																							<p id={styles.productName}>{element.produto}</p>
																							<p id={styles.descriItem}>{element.descricao}</p>
																						</div>
																					</div>
																				</div>
																				<div className="row" onClick={() => this.openItem(element, null)}>


																					<div className="col-md-12">
																						{
																							element.is_pizza == 'S' && element.qt_particiona > 1 ? (
																								<div className="ui tag labels labelsPrice">
																									<a className="ui label pull-right customPrice">
																										partir de R$ {element.PRECO.toFixed(2)}
																									</a>
																								</div>

																							) : (

																								<div className="ui tag labels ">
																									<a className="ui label pull-right"
																										style={{
																											fontSize: 12,
																											background: GLOBAL.COLORS.primary,
																											color: '#fff'
																										}}
																									>
																										R$ {element.PRECO.toFixed(2)}
																									</a>
																								</div>
																							)
																						}

																					</div>
																				</div>
																			</div>
																		</div>

																	);

																})

															}
														</div>
													</div>

												</div>

											);
										})
									}
								</div>
							</div>
							<div className="col-md-3 col-sm-3 col-xs-12">

								<ItensPedidoNaMesa showPag={true}
									itens={this.state.itensPedido}
									loja={this.state.loja}
									openItem={this.editItem}
									taxa={0}
									additionalClass="affix hidden-xs"
									funcVerificaLoja={this.veirificaLojaAberta}
									isFromMobile
									mesa={this.state.mesa}
									funcAlert={this.resolveAlert}
								/>
							</div>
						</div>

					</div>
				</div>




				{/* Modal para itens */}
				<Modal show={this.state.showItemModal} onHide={this.closeModal} dialogClassName="customModal">
					<div className="row">
						<FontAwesomeIcon icon={faTimesCircle} className="faTimes faTimespizza pull-right visible-xs" onClick={this.closeModal} />
						<h2 className="text-center visible-xs">{this.state.itemNow.produto}</h2>
						<div className="col-md-8">

							<div className="listchoose padding">
								{this.montaView()}
							</div>


							<div className="obsPizza">
								<textarea maxLength="60" placeholder="Digite aqui sua a observação" value={this.state.obsItemPizza} onChange={this.handleObsPizza}></textarea>
							</div>

							<div className="action-itens-pizza">
								{(itemNow.aceita_dec !== "S" || (itemNow.aceita_dec === "S" && (itemNow.is_pizza === "S" || itemNow.is_combo === "S"))) && <div
									className="circleAddPizza"
									onClick={this.minusItem}
								>
									<FontAwesomeIcon icon={faMinus} className="faMinusPizza" />
								</div>}





								{
									(itemNow.aceita_dec !== "S" || (itemNow.aceita_dec === "S" && (itemNow.is_pizza === "S" || itemNow.is_combo === "S"))) ? (
										<>
											<InputQt
												type="number"
												value={this.state.qtItem}
												onChange={this.manualQtAdd}
												readOnly={true}
												onKeyPress={() => false}
												placeholder={"Quantidade"}
											/>
										</>
									) : (
										<ColumnContainer>
											<span>Informe a quantidade</span>
											<InputQt
												type={"number"}
												value={this.state.qtItem}
												onChange={this.manualQtAdd}
												readOnly={this.state.itemNow.aceita_dec !== "S"}
												aceitaDec={this.state.itemNow.aceita_dec === "S"}

												maxLength={6}
												placeholder={"Quantidade"}
											/>
										</ColumnContainer>
									)
								}







								{(itemNow.aceita_dec !== "S" || (itemNow.aceita_dec === "S" && (itemNow.is_pizza === "S" || itemNow.is_combo === "S"))) && <div
									className="circleAddPizza"
									onClick={this.plusItem}
								>
									<FontAwesomeIcon icon={faPlus} className="faPlusPizza" />
								</div>}
							</div>
						</div>


						{/* Agora vem o lado direito */}
						<div className="col-md-4 infoProdSelect hidden-xs">

							<FontAwesomeIcon icon={faTimesCircle} className="faTimes faTimespizza pull-right" onClick={this.closeModal} />

							<div className="imgInfoProdSelect hidden-xs">
								<img src={this.state.itemNow.imagem} />
							</div>
							<h2>{this.state.itemNow.produto}</h2>
						</div>

					</div>

					<Modal.Footer className="customFooterModal footerModalAdd">
						<div className="row">
							<div className="col-md-8 col-sm-8 col-xs-6">
								{
									!this.state.isEdit ? (<button type="button" onClick={this.addItem} className="btn btn-primary btn-lg btn-block btn-add-pizza">ADICIONAR</button>)
										: (
											<div className="row">
												<div className="col-md-6 col-sm-6 col-xs-6">
													<button type="button" onClick={this.handleEdit} className="btn btn-primary btn-lg btn-block btn-add-pizza"><FontAwesomeIcon icon={faCheckCircle} className="faCheckCircle" /></button>
												</div>
												<div className="col-md-6 col-sm-6 col-xs-6">
													<button type="button" onClick={this.handleExcludeItem} className="btn btn-primary btn-lg btn-block excluirItem excluiritempizza"><FontAwesomeIcon icon={faTrashAlt} className="faTrashAlt" /></button>
												</div>


											</div>
										)
								}
							</div>
							<div className="col-md-4 col-sm-4 col-xs-6">
								<div className="col-total-pizza" >
									<p>R$ {this.state.totalDoItem.toFixed(2)}</p>
								</div>
							</div>
						</div>
					</Modal.Footer>
				</Modal>



				{/* modal de visualização das fotos */}
				<Modal show={this.state.showPic} onHide={this.handleCloseImgNow}>
					<FontAwesomeIcon icon={faTimesCircle} className="faTimes faTimespizza pull-right " onClick={this.handleCloseImgNow} />
					<img src={this.state.imgNow} className="img-now" />
					<div className="infoProdAmpliado">
						<h1>{this.state.prodNow}</h1>
						<p>{this.state.descriNow}</p>
					</div>
				</Modal>



				{/* getCPF */}

				<CustomModal show={this.state.showGetCPF} >
					<CustomModal.Header style={{ background: '#fff' }}>
						<Modal.Title style={{ color: '#333' }}>Informe seu CPF</Modal.Title>
					</CustomModal.Header>
					<CustomModal.Body className="bodyModalCpf">
						<InputCPF
							onChange={this.handleCpfTyped}
							value={this.state.cpfTyped}
						/>
					</CustomModal.Body>
					<CustomModal.Footer style={{ background: '#fff' }}>
						{this.state.cpfTyped.length >= 11 && <Button onClick={this.handleOkCpf}>OK</Button>}
					</CustomModal.Footer>
				</CustomModal>




				{/* ALERTS */}

				<Modal show={this.state.showAlertError} onHide={this.handleCloseAll}>
					<Modal.Header style={{ background: '#EACACA' }} closeButton>
						<Modal.Title style={{ color: '#C6807F' }}>Ops... Algo deu errado</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{ background: '#EACACA' }}>
						<p>{this.state.textAlertError}</p>
					</Modal.Body>
					<Modal.Footer style={{ background: '#EACACA' }}>
						<Button onClick={this.handleCloseAll}>Fechar</Button>
					</Modal.Footer>
				</Modal>


				<Modal show={this.state.showAlertSucces}>
					<Modal.Header style={{ background: '#D4EACA' }} closeButton>
						<Modal.Title style={{ color: '#4F844F' }}>Muito bem !</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{ background: '#D4EACA' }}>
						<p>{this.state.textAlertSucces}</p>
					</Modal.Body>
					<Modal.Footer style={{ background: '#D4EACA' }}>
						<Button onClick={this.handleCloseAll}>Fechar</Button>
					</Modal.Footer>
				</Modal>



			</div>
		);

	}

}



const mapStateToProps = state => ({
	rdUser: state.user,
	rdOrder: state.order
})

const mapDispathToPros = dispatch => bindActionCreators(Actions, dispatch)

export default withRouter(connect(mapStateToProps, mapDispathToPros)(EstouNaMesa))

